import React from 'react';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';
import { push } from 'react-router-redux';

import * as abonadosActions from 'modules/abonados/action';
import * as generalActions from 'modules/general/action';

import ItemListC from './itemList';
import { checkPermissions } from 'core/generalFunctions';

@connect(store => ({
  usuariosList: store.getIn(['abonados', 'lista', 0]) || [],
  abonadosList: store.getIn(['abonados', 'lista', 1]) || [],
}))
export default class extends React.Component {
  componentDidMount = () => this.props.dispatch(generalActions.dashboard_changeTitle('ABONADOS'));
  add = () => this.props.dispatch(push('/dashboard/abonados/add/new/false'));
  buscarAbonados = e => {
    if (e.target.value.length > 2) this.props.dispatch(abonadosActions.get(e.target.value, true));
    else this.props.dispatch(abonadosActions.clear('lista'));
  };
  render() {
    const { abonadosList, usuariosList } = this.props;
    return (
      <Container fluid={true}>
        <Row>
          <Col md={{ size: 7, offset: 3 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <Row>
                <Col md={1}>
                  <FontAwesome name="search" className="pt-30" size="2x" />
                </Col>
                <Col md={11}>
                  <MaterialUI.TextField hintText="Nombre, apellido, DNI o email" floatingLabelText="Buscar" fullWidth={true} name="queryAbonado" onChange={this.buscarAbonados} />
                </Col>
              </Row>
            </MaterialUI.Paper>
          </Col>
          <Col md={{ size: 6 }} className="pt-30">
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding dividerList">
                {usuariosList.map(abonado => (
                  <ItemListC abonado={abonado} key={abonado.get('id')} isUser />
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
          <Col md={{ size: 6 }} className="pt-30">
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding dividerList">
                {abonadosList.map(abonado => (
                  <ItemListC abonado={abonado} key={abonado.get('id')} />
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
          <Col md={{ size: 6, offset: 2 }} className="pt-30 no-print">
            <Row>
              <Col md="2" className="textCenter">
                <FontAwesome name="ticket" className="iconInfo" />
              </Col>
              <Col md="10">Ultima reserva creada</Col>
            </Row>
            <Row>
              <Col md="2" className="textCenter">
                <FontAwesome name="ticket" className="blue iconInfo" />
                <FontAwesome name="check" className="blue iconInfo pr-10" />
              </Col>
              <Col md="10">Cantidad de reservas concretadas</Col>
            </Row>
            <Row>
              <Col md="2" className="textCenter">
                <FontAwesome name="address-card-o" className="iconInfo" />
              </Col>
              <Col md="10">DNI</Col>
            </Row>
          </Col>
          <Col md={{ size: 4 }} className="pt-30 no-print">
            <Row>
              <Col md="2" className="textCenter">
                <FontAwesome name="address-card-o" className="iconInfo blue" />
              </Col>
              <Col md="10">DNI Validado</Col>
            </Row>
            <Row>
              <Col md="2" className="textCenter">
                <FontAwesome name="user" className="iconInfo" />
              </Col>
              <Col md="10">Usuario abonado</Col>
            </Row>
            <Row>
              <Col md="2" className="textCenter">
                <FontAwesome name="mobile" className="iconInfo" style={{ fontSize: 20 }} />
              </Col>
              <Col md="10">Usuario app</Col>
            </Row>
            <Row>
              <Col md="2" className="textCenter">
                <FontAwesome name="star" className="iconInfo" style={{ fontSize: 20 }} />
              </Col>
              <Col md="10">Tiene a esta empresa como favorita</Col>
            </Row>
          </Col>
        </Row>

        {checkPermissions(['admin', 'administrador_abonados']) && (
          <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={this.add.bind(this)}>
            <FontAwesome name="plus" />
          </MaterialUI.FloatingActionButton>
        )}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/abonados/components/main.js